import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

import useContextMenu from '@Hooks/useContextMenu';

import { ReactComponent as MoreIconSVG } from '@Assets/Svgs/ic_more.svg';
import { ContextMenu, Item } from '@Components/Common/ContextMenu';
import TX from '@Components/Common/Text';

const ShowMoreButton = ({
  achievementId,
  handleDuplicateAchievementClick,
  handleSetSelectedAchievementId,
  handleIsNoticeDeleteModalVisible,
}) => {
  const { isContextMenuVisible, handleShowContextMenuClick } = useContextMenu();

  const handleShowMoreButtonClick = event => {
    handleSetSelectedAchievementId(achievementId);
    handleShowContextMenuClick(event);
  };

  return (
    <>
      <ShowMoreButtonContainer onClick={event => handleShowMoreButtonClick(event)}>
        <ShowMoreButtonIcon />
      </ShowMoreButtonContainer>

      {isContextMenuVisible && (
        <ContextMenu position={{ top: 32, right: 0 }}>
          <Item onClick={() => handleDuplicateAchievementClick(achievementId)}>
            <TX.FootnoteM>복제</TX.FootnoteM>
          </Item>
          <Item onClick={handleIsNoticeDeleteModalVisible}>
            <TX.FootnoteM>삭제</TX.FootnoteM>
          </Item>
        </ContextMenu>
      )}
    </>
  );
};

ShowMoreButton.propTypes = {
  achievementId: PropTypes.number.isRequired,
  handleDuplicateAchievementClick: PropTypes.func.isRequired,
  handleSetSelectedAchievementId: PropTypes.func.isRequired,
  handleIsNoticeDeleteModalVisible: PropTypes.func.isRequired,
};

const FlexAlignCenterCSS = css`
  display: flex;
  align-items: center;
`;

const ShowMoreButtonContainer = styled.button`
  ${FlexAlignCenterCSS}
  justify-content: center;

  width: 32px;
  height: 32px;

  border: none;
  background-color: transparent;
  cursor: pointer;
`;

const ShowMoreButtonIcon = styled(MoreIconSVG)`
  width: 16px;
  height: 16px;
`;

export default ShowMoreButton;
